import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch
} from "react-router-dom";

function SpanishIndex() {
  let match = useRouteMatch();

  function handleClick(e) {
    e.preventDefault();
  } 

  return (
    <React.Fragment>

      { /* Start Prealoader Area */ }
        <div className="preloader-area">
            <div className="sk-circle">
                <div className="sk-circle1 sk-child"></div>
                <div className="sk-circle2 sk-child"></div>
                <div className="sk-circle3 sk-child"></div>
                <div className="sk-circle4 sk-child"></div>
                <div className="sk-circle5 sk-child"></div>
                <div className="sk-circle6 sk-child"></div>
                <div className="sk-circle7 sk-child"></div>
                <div className="sk-circle8 sk-child"></div>
                <div className="sk-circle9 sk-child"></div>
                <div className="sk-circle10 sk-child"></div>
                <div className="sk-circle11 sk-child"></div>
                <div className="sk-circle12 sk-child"></div>
            </div>
        </div>
        { /* End Prealoader Area */ }

        { /* Start Navbar Area */ }
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="container">
                <a className="navbar-brand pirulen-font" href="/"><span>A</span>glaya</a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
    
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item"><a className="nav-link" href="#home">Inicio</a></li>
                        <li className="nav-item"><a className="nav-link" href="#about">¿Quienes Somos?</a></li>
                        <li className="nav-item"><a className="nav-link" href="#services">Servicios</a></li>
                        <li className="nav-item"><a className="nav-link" href="#portfolio">Portafolio</a></li>
                        <li className="nav-item"><a className="nav-link" href="#contact">Cont&aacute;ctanos</a></li>
                        <li className="nav-item">
                          <a className="nav-link" href="/en" title="Eglish Version">
                            <img src="./../img/united-states-of-america.png" alt="english"/>
                          </a>                          
                        </li>
                        <li className="nav-item"><a className="nav-link" href="#" data-toggle="modal" data-target="#myModal"><span></span></a></li>
                    </ul>
                </div>
            </div>
        </nav>
        { /* End Navbar Area */ }

        { /* Right Side Modal */ }
        <div className="modal right fade" id="myModal" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div className="modal-body">
                        <div className="logo pirulen-font"><a href="/">Aglaya <span>Software</span></a></div>
                        <p>Eficiencia, control, optimizaci&oacute;n de recursos, ofrecemos herramientas que te permiten tener una posici&oacute;n privilegiada en el mercado, te apoyamos a generar valor a tu empresa optimizando tus mismos recursos a trav&eacute;s del uso de tecnolog&iacute;a.</p>
                        <ul className="modal-contact-info">
                            { /* <li><i className="icofont-google-map"></i> <b>Los Robles</b>Managua, Nicaragua</li> */ }
                            <li><i className="icofont-ui-call"></i> <b>+(505) 5704 8835</b>Nicaragua</li>
                            <li><i className="icofont-ui-call"></i> <b>+34 (640) 85 84 87</b>Espa&ntilde;a</li>
                            <li><i className="icofont-envelope"></i> <b>info@aglayasoftware.com</b>Escr&iacute;benos</li>
                        </ul>

                        { /* <ul className="social-links">
                            <li><a href="javascript: void(0)"><i className="icofont-facebook"></i></a></li>
                            <li><a href="javascript: void(0)"><i className="icofont-twitter"></i></a></li>
                            <li><a href="javascript: void(0)"><i className="icofont-instagram"></i></a></li>
                            <li><a href="javascript: void(0)"><i className="icofont-linkedin"></i></a></li>
                            <li><a href="javascript: void(0)"><i className="icofont-pinterest"></i></a></li>
                        </ul> */ }
                    </div>
                </div>
            </div>
        </div>
		{ /* End Right Side Modal */ }

        { /* Start Main Banner */ }
        <div id="home" className="main-banner item-bg-two">
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="hero-content">
                            <h5>¡Codificando tus sueños!</h5>
                            <h1 className="pirulen-font"><span>Aglaya</span> Software</h1>
                            <p>Desarrolladores Profesionales para convertir tus ideas en grandes sistemas.</p>                            
                            { /* <a href="#contact" className="btn btn-primary">Cont&aacute;ctanos</a> */ }
                            { /* <a href="https://www.youtube.com/watch?v=bk7McNUjWgw" className="video-btn"><i className="icon icon-Play"></i> Watch Video</a> */ }
                        </div>
                    </div>
                </div>
            </div>

            <div className="down_arrow">
                <a href="#about" className="scroll_down"></a>
            </div>

            <div className="animation-box1"><img src="../img/glasses.png" alt="service"/></div>            
            <div className="animation-box2"><img src="../img/cloud.png" alt="service"/></div>
            <div className="animation-box3"><img src="../img/code.png" alt="service"/></div>
            <div className="animation-box6"><img src="../img/6.png" alt="service"/></div>

            <div className="creative-box1"></div>
        </div>
        { /* End Main Banner */ }

        { /* Start Welcome Area */ }
        <section id="" className="welcome-area ptb-100">
            <div className="container">
                <div className="section-title">
                    <h2><b>Aglaya Software</b></h2>
                    <p>Eficiencia, control, optimizaci&oacute;n de recursos, ofrecemos herramientas que te permiten tener una posici&oacute;n privilegiada en el mercado, te apoyamos a generar valor a tu empresa optimizando tus mismos recursos a trav&eacute;s del uso de tecnolog&iacute;a.</p>
                </div>

                { /* <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-box">
                            <i className="icon icon-Star"></i>
                            <h3>Creatividad</h3>
                            <p>Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-box">
                            <i className="icon icon-Starship"></i>
                            <h3>Innovaci&oacute;n</h3>
                            <p>Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                        <div className="single-box">
                            <i className="icon icon-ChartUp"></i>
                            <h3>Fast Support</h3>
                            <p>Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                        </div>
                    </div>
                </div> */ }
            </div>
        </section>
        { /* End Welcome Area */ }

        { /* Start About Area */ }
        <section id="about" className="about-area ptb-100 bg-f9f9f9">
            <div className="container">
                <div className="section-title">
                    <h2>¿<b className="blueText">Qui&eacute;nes</b> Somos?</h2>
                </div>

                <div className="row">
                    <div className="m-b-20 col-lg-6 offset-lg-0 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-10 offset-1">
                        <img data-src="../img/banner-pc-es.png" alt="Aglaya Software - Desarrollo de Software" style={{ width: '100%' }} loading="lazy" className="lazyload"/>
                    </div>

                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="row">
                            <div className="about-slides">
                                <div className="col-lg-12">
                                    <div className="about-title">
                                        <h3><b className="blueText">Aglaya </b>Software</h3>
                                    </div>

                                    <div className="our-mission">
                                        <p>Somos un equipo creativo, innovadores y con experiencia en situaciones empresariales, aportamos más que solo la digitalización de tus anhelos.</p>
                                        <p>Ofrecemos soluciones tecnol&oacute;gicas integrales &uacute;nicas para tu empresa, con esquemas vers&aacute;tiles y accesibles, que se adaptan a cada empresa en cada industria.</p>
                                        <br/>
                                        <h5>¡T&uacute; lo imaginas, <span className="blueText">nosotros lo desarrollamos!</span></h5>
                                    </div>
                                    
                                </div>

                                <div className="col-lg-12">
                                    <div className="about-title">
                                        <h3>¿Qu&eacute; nos<b className="blueText"> diferencia</b>?</h3>
                                        <p>Somos un equipo apasionado, con experiencia en diferentes rubros del mercado, hemos logrado implementar soluciones tecnol&oacute;gicas para mejorar la eficiencia y brindarles valor agregado a nuestros clientes en:</p>
                                    </div>

                                    <div className="why-choose-us">
                                        <div className="row m-0">
                                            <div className="col-lg-4 col-md-4 p-0">
                                                <div className="single-choose">
                                                    <i className="icon icon-Truck"></i>
                                                    <h5 className="blueText">Log&iacute;stica</h5>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 p-0">
                                                <div className="single-choose">
                                                    <i className="icon icon-Dollars"></i>
                                                    <h5 className="blueText">Finanzas</h5>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 p-0">
                                                <div className="single-choose">
                                                    <i className="icon icon-WorldWide"></i>
                                                    <h5 className="blueText">Marketing</h5>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 p-0">
                                                <div className="single-choose">
                                                    <i className="icon icon-FullShoppingCart"></i>
                                                    <h5 className="blueText">E-Commerce</h5>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 p-0">
                                                <div className="single-choose">
                                                    <i className="icon icon-DesktopMonitor"></i>
                                                    <h5 className="blueText">Producci&oacute;n</h5>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 p-0">
                                                <div className="single-choose">
                                                    <i className="icon icon-Chart"></i>
                                                    <h5 className="blueText">Business Intelligence</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="animation-box1"><img data-src="../img/cloud-computing.png" width="70px" alt="service" loading="lazy" className="lazyload"/></div>
            <div className="animation-box2"><img data-src="../img/devices-blue.png" alt="service" loading="lazy" className="lazyload"/></div>
            <div className="animation-box3"><img data-src="../img/1.png" alt="service" className="lazyload"/></div>
            <div className="animation-box6"><img data-src="../img/code-round.png" width="70px" alt="service" loading="lazy" className="lazyload"/></div>
        </section>
        { /* End About Area */ }

        { /* Start Services Area */ }
        <section id="services" className="services-area ptb-100">
            <div className="container">
                <div className="section-title">
                    <h2>Nuestros <b className="blueText">Servicios</b></h2>     
                    
                    <p className="mw-100">Nos enfocamos en proveerte las herramientas adecuadas para prepararte para la transformaci&oacute;n digital de tu empresa.</p>
                    <p className="mw-100">Tenemos un equipo de profesionales especializados en diferentes &aacute;reas para garantizarte calidad en tus requerimientos. Trabajamos con las tecnolog&iacute;as y soluciones que mejor se integren a tus necesidades:</p>
                </div>                
                   
                <div className="row text-center justify-content-md-center">
                  <div className="col-12 m-b-20">
                    <h4><b className="blueText">Dise&ntilde;o</b> Web</h4>     
                  </div>

                  <div className="col-lg-3 col-md-6 col-sm-6 p-b-30">
                      <div className="single-services">
                          <i className="icon icon-Web"></i>
                          <h3 className="blueText">Dise&ntilde;o Web</h3>
                          <p>Tu tarjeta de presentaci&oacute;n ante tus clientes. Incluimos dominio, alojamiento y mantenimiento.</p><br />
                      </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-sm-6 p-b-30">
                      <div className="single-services">
                          <i className="icon icon-Pen"></i>
                          <h3 className="blueText">SEO & UX/UI Design</h3>
                          <p>Creamos sitios que generan valor, enfocados en darle la mejor experiencia al usuario.</p><br />
                      </div>
                  </div> 

                  <div className="col-lg-3 col-md-6 col-sm-6 p-b-30">
                    <div className="single-services">
                        <i className="icon icon-Eye"></i>
                        <h3 className="blueText">AR & VR</h3>
                        <p>Ofr&eacute;cele a tus clientes nuevas experiencias para conocer tus productos y servicios.</p><br />
                    </div>
                  </div>

                  <div className="col-12 m-b-20 ">
                    <h4><b className="blueText">Desarrollo</b> A la Medida</h4>     
                  </div>
                  
                  <div className="col-lg-3 col-md-6 col-sm-6 p-b-30">
                      <div className="single-services">
                          <i className="icon icon-WorldWide"></i>
                          <h3 className="blueText">Desarrollo Web</h3>
                          <p>Construimos y administramos sistemas web según tus requerimientos.</p>
                      </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-sm-6 p-b-30">
                    <div className="single-services">
                        <i className="icon icon-DesktopMonitor"></i>
                        <h3 className="blueText">Desarrollo Desktop</h3>
                        <p>Dise&ntilde;amos soluciones eficientes y amigables para entornos de escritorio.</p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-sm-6 p-b-30">
                      <div className="single-services">
                          <i className="icon icon-Phone"></i>
                          <h3 className="blueText">Desarrollo M&oacute;vil</h3>
                          <p>Somos especialistas en desarrollo de aplicaciones multiplataforma con tecnolog&iacute;as de vanguardia.</p>
                      </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-sm-6 p-b-30">
                    <div className="single-services">
                        <i className="icon icon-FullShoppingCart"></i>
                        <h3 className="blueText">E-Commerce</h3>
                        <p>Lleva tu tienda al siguiente nivel, con nuestras soluciones e-commerce, amigables e intuitivas.</p>
                    </div>
                  </div>

                  <div className="col-12 m-b-20 ">
                    <h4><b className="blueText">Asistentes</b> Inteligentes</h4>     
                  </div>

                  <div className="col-lg-3 col-md-6 col-sm-6 p-b-30">
                      <div className="single-services">
                          <i className="icon icon-Microphone"></i>
                          <h3 className="blueText">Plataformas de Voz</h3>
                          <p>Amazon Alexa, asistente inteligente m&aacute;s utilizados. ¡Agreg&aacute;lo a tu staff!</p>
                      </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-sm-6 p-b-30">
                      <div className="single-services">
                          <i className="icon icon-Message"></i>
                          <h3 className="blueText">Chatbots</h3>
                          <p>Impulsa tu negocio a trav&eacute;s de chatbots con capacidad de interactuar con tus clientes.</p>
                      </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-sm-6 p-b-30">
                    <div className="single-services">
                        <i className="icon icon-Briefcase"></i>
                        <h3 className="blueText">Asistentes Virtuales</h3>
                        <p>Dale una cara a tu empresa con asistentes virtuales directamente en tu sitio web.</p>
                    </div>
                  </div>                
              </div>
            </div>
        </section>
        { /* End Services Area */ }

        { /* Start Subscribe Area */ }
        <div className="subscribe-area">
          <div className="container">
              <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                      <p><b>¡Calidad Garantizada!</b> Trabajamos con equipos &aacute;giles enfocados en desarrollar soluciones para mejorar la experiencia de nuestros clientes con estrictos controles de calidad en cada fase del proyecto.</p>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12">
                      <div className="partner-slides">
                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/nodejs.png" alt="tech"/>
                              </div>
                          </div>
                          
                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/python.png" alt="tech"/>
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/django.png" alt="tech"/> 
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/postgresql.png" alt="tech"/>
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/sqlserver.png" alt="tech"/>
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/css3.png" alt="tech"/>
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/bootstrap.png" alt="tech"/>
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/os-ios.png" alt="tech"/>
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/android.png" alt="tech"/>
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/ionic.png" alt="tech"/>
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/angular.png" alt="tech"/>
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/aws.png" alt="tech"/>
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/less.png" alt="tech"/>
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/react.png" alt="tech"/> 
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/salesforce.png" alt="tech"/>
                              </div>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                              <div className="item text-center">
                                  <img className="prog-icon owl-lazy" loading="lazy" data-src="../img/sass.png" alt="tech"/>
                              </div>
                          </div>

                      </div>
                </div>
              </div>
          </div>
      </div>
      { /* End Subscribe Area */ }

        { /* Start Portfolio Area */ }
        <section id="portfolio" className="portfolio-area ptb-100 bg-f9f9f9">
            <div className="container">
                <div className="section-title">
                    <h2><b>Portafolio</b></h2>
                    <p>Algunos proyectos que han ayudado a aumentar la eficiencia en los procesos de negocio de nuestros clientes:</p>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-work">
                            <div className="work-image">
                                <img data-srcset="../img/portafolio/lawyer-400.jpg 400w,
                                ../img/portafolio/lawyer-600.jpg 600w,
                                ../img/portafolio/lawyer-800.jpg 800w,
                                ../img/portafolio/lawyer.jpg 1000w"

                                data-src="../img/portafolio/lawyer-600.jpg" 
                                
                                alt="Aglaya Software - Tracking de Tramites Legales"
                                
                                loading="lazy"
                                className="lazyload"/>

                                <a href="../img/portafolio/lawyer.jpg" className="popup-btn" title="Tracking de Tr&aacute;mites Legales"><i className="icon icon-Search"></i></a>
                            </div>
                            <h3>Tracking de Tr&aacute;mites Legales</h3>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-work">
                            <div className="work-image">
                                <img data-srcset="../img/portafolio/dentist-software-400.jpg 400w,
                                ../img/portafolio/dentist-software-600.jpg 600w,
                                ../img/portafolio/dentist-software-800.jpg 800w,
                                ../img/portafolio/dentist-software.jpg 1000w"

                                data-src="../img/portafolio/dentist-software-600.jpg" 

                                alt="Aglaya Software - Control de Pacientes"
                                
                                loading="lazy"
                                className="lazyload"/>

                                <a href="../img/portafolio/dentist-software.jpg" className="popup-btn" title="Control de Pacientes"><i className="icon icon-Search"></i></a>
                            </div>
                            <h3>Control de Pacientes</h3>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-work">
                            <div className="work-image">
                                <img data-srcset="../img/portafolio/service-desk-400.jpg 400w,
                                ../img/portafolio/service-desk-600.jpg 600w,
                                ../img/portafolio/service-desk-800.jpg 800w,
                                ../img/portafolio/service-desk.jpg 1000w"
                                
                                data-src="../img/portafolio/service-desk-600.jpg" 

                                alt="Aglaya Software - Gestion y Tracking de Incidencias"
                                
                                loading="lazy"
                                className="lazyload"/>

                                <a href="../img/portafolio/service-desk.jpg" className="popup-btn" title="Gesti&oacute;n y Tracking de Incidencias"><i className="icon icon-Search"></i></a>
                            </div>
                            <h3>Gesti&oacute;n y Tracking de Incidencias</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        { /* End Portfolio Area */ }

        { /* Start Feedback Area */ }
        { /* <section className="feedback-area ptb-100 bg-f9f9f9">
            <div className="container">
                <div className="section-title">
                    <h2>Our <b>Feadback</b></h2>
                    <p>Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                </div>

                <div className="row">
                    <div className="feedback-slides">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="single-feedback">
                                <div className="client-info">
                                    <div className="img">
                                        <img src="../img/client-avatar1.jpg" alt="client">
                                    </div>
                                    <h4>Josh Buttler</h4>
                                    <span>Web Developer</span>
                                </div>

                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>

                                <i className="icofont-quote-right"></i>
                            </div>
                        </div>

                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="single-feedback">
                                <div className="client-info">
                                    <div className="img">
                                        <img src="../img/client-avatar2.jpg" alt="client">
                                    </div>
                                    <h4>Josh Buttler</h4>
                                    <span>Web Developer</span>
                                </div>

                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>

                                <i className="icofont-quote-right"></i>
                            </div>
                        </div>

                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="single-feedback">
                                <div className="client-info">
                                    <div className="img">
                                        <img src="../img/client-avatar3.jpg" alt="client">
                                    </div>
                                    <h4>Josh Buttler</h4>
                                    <span>Web Developer</span>
                                </div>

                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>

                                <i className="icofont-quote-right"></i>
                            </div>
                        </div>

                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="single-feedback">
                                <div className="client-info">
                                    <div className="img">
                                        <img src="../img/client-avatar1.jpg" alt="client">
                                    </div>
                                    <h4>Josh Buttler</h4>
                                    <span>Web Developer</span>
                                </div>

                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>

                                <i className="icofont-quote-right"></i>
                            </div>
                        </div>

                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="single-feedback">
                                <div className="client-info">
                                    <div className="img">
                                        <img src="../img/client-avatar2.jpg" alt="client">
                                    </div>
                                    <h4>Josh Buttler</h4>
                                    <span>Web Developer</span>
                                </div>

                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>

                                <i className="icofont-quote-right"></i>
                            </div>
                        </div>

                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="single-feedback">
                                <div className="client-info">
                                    <div className="img">
                                        <img src="../img/client-avatar3.jpg" alt="client">
                                    </div>
                                    <h4>Josh Buttler</h4>
                                    <span>Web Developer</span>
                                </div>

                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>

                                <i className="icofont-quote-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> */ }
        { /* End Feedback Area */ }

        { /* Start Blog Area */ }
        { /* <section id="blog" className="blog-area ptb-100">
            <div className="container">
                <div className="section-title">
                    <h2>Our Latest <b>News</b></h2>
                    <p>Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-blog-post">
                            <div className="post-thumbnail">
                                <a href="#"><img src="../img/blog-img1.jpg" alt="blog-img"></a>
                            </div>

                            <div className="post-content">
                                <h3><a href="#">Risus commodo viverra maecenas accumsan lacus vel facilisis.</a></h3>
                                <a href="#" className="read-more">Read More</a>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-blog-post">
                            <div className="post-thumbnail">
                                <a href="#"><img src="../img/blog-img2.jpg" alt="blog-img"></a>
                            </div>

                            <div className="post-content">
                                <h3><a href="#">Risus commodo viverra maecenas accumsan lacus vel facilisis.</a></h3>
                                <a href="#" className="read-more">Read More</a>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                        <div className="single-blog-post">
                            <div className="post-thumbnail">
                                <a href="#"><img src="../img/blog-img3.jpg" alt="blog-img"></a>
                            </div>

                            <div className="post-content">
                                <h3><a href="#">Risus commodo viverra maecenas accumsan lacus vel facilisis.</a></h3>
                                <a href="#" className="read-more">Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> */ }
        { /* End Blog Area */ }

        { /* Start Work With Us Area */ }
        { /* <section className="work-with-us ptb-100">
            <div className="container">
                <h3>Want to work with us?</h3>
                <span>Lets talk about project</span>
                <a href="#" className="btn btn-primary">Get Started</a>
            </div>
            <div className="animation-box1"><img src="../img/3.png" alt="image"></div>
            <div className="animation-box2"><img src="../img/4.png" alt="image"></div>
            <div className="animation-box3"><img src="../img/1.png" alt="image"></div>
        </section> */ }
        { /* End Work With Us Area */ }       

        { /* Start Contact Area */ }
        <section id="contact" className="contact-area ptb-100">
            <div className="container">
                <div className="section-title">
                    <h2><b>Cont&aacute;ctanos</b></h2>
                    <p>¡Cu&eacute;ntanos acerca de tu proyecto. Nosotros nos encargaremos de hacerlo realidad!</p>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="contact-box">
                            <div className="icon">
                                <i className="icofont-google-map"></i>
                            </div>
                            <h4>Direcci&oacute;n</h4>
                            { /* <p><a href="javascript: void(0)">Los Robles</a></p> */ }
                            <p><a href="#" onClick={ handleClick }>Managua, Nicaragua</a></p>
                            <p><a href="#" onClick={ handleClick }>Madrid, Espa&ntilde;a</a></p>
                            <br/>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="contact-box">
                            <div className="icon">
                                <i className="icofont-envelope"></i>
                            </div>
                            <h4>Email</h4>
                            <p><a href="#" onClick={ handleClick }>info@aglayasoftware.com</a></p>
                            <p><a href="#" onClick={ handleClick }></a></p>
                            <br/>
                            { /* <p><a href="javascript: void(0)">support@aglayasoftware.com</a></p> */ }
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                        <div className="contact-box">
                            <div className="icon">
                                <i className="icofont-phone"></i>
                            </div>
                            <h4>Tel&eacute;fonos</h4>
                            <p><a href="#" onClick={ handleClick }>+(505) 5704 8835</a></p>
                            <p><a href="#" onClick={ handleClick }>+34 (640) 85 84 87</a></p>
                            <br/>
                            { /* <p><a href="javascript: void(0)">+505 5820 5929</a></p> */ }
                        </div>
                    </div>

                    { /* <div className="col-lg-4 col-md-12 col-sm-12">
                        <div className="get-in-touch">
                            <h3>Get in Touch</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                            <ul>
                                <li><a href="#" className="icofont-facebook"></a></li>
                                <li><a href="#" className="icofont-twitter"></a></li>
                                <li><a href="#" className="icofont-instagram"></a></li>
                                <li><a href="#" className="icofont-linkedin"></a></li>
                            </ul>
                        </div>
                    </div> */ }

                    { /* <div className="col-lg-8 col-md-12 col-sm-12">
                        <form id="contactForm">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="form-group">
                                        <input type="text" className="form-control" name="name" id="name" required data-error="Please enter your name" placeholder="Name">
                                        <div className="help-block with-errors"></div>
                                    </div>
                                </div>
                                
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="form-group">
                                        <input type="email" className="form-control" name="email" id="email" required data-error="Please enter your email" placeholder="Email">
                                        <div className="help-block with-errors"></div>
                                    </div>
                                </div>
                                
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="form-group">
                                        <textarea name="message" className="form-control" id="message" cols="30" rows="4" required data-error="Write your message" placeholder="Message"></textarea>
                                        <div className="help-block with-errors"></div>
                                    </div>
                                </div>
                                
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <button type="submit" className="btn btn-primary">Send Message</button>
                                    <div id="msgSubmit" className="h3 text-center hidden"></div>
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                        </form>        
                    </div> */ }
                </div>
            </div>
        </section>
         { /* End Contact Area */ }

        { /* Start Footer Area */ }
		<footer className="footer-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6">
                        <p>Copyright &copy; 2020 Aglaya Software. Todos los Derechos Reservados.</p>
                    </div>
                </div>
            </div>
        </footer>
    { /* End Footer Area */ }
    
    <div className="go-top"><i className="icofont-stylish-up"></i></div>   
      
    </React.Fragment>
  );
}

export default SpanishIndex;
